import React from 'react';
import FormDataJson from 'form-data-json-convert';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mutateImageUrl } from '../../../wordpress';
import ProductWarningText from './ProductWarningText';

/**
 * Product component
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */
const Product = ({
    product,
    section,
    selectedProducts,
    isSelected,
    onSelect,
    onSelectNamedProduct,
    onRemove,
    onCustomise,
    projectTitle,
    boldProductOptions,
    currentBuildIndex,
}) => {
    const isInStock = product.totalInventory > 0;
    const prodIdParsed = product && product.id.split('/').pop();
    const classes = classNames('product', {
        'product-selected': isSelected,
        'product-sale': product.on_sale,
    });
    const imgSrc = mutateImageUrl(product.featuredImage && product.featuredImage.url, 480, 480);
    const isCustomisable = boldProductOptions && boldProductOptions[1]?.option_sets?.length > 0;
    const isAccessorySection =
        section === 'accessory1' || section === 'accessory2' || section === 'accessory3' || section === 'accessory4';

    const selectProduct = (e) => {
        const productFormJsonValues = FormDataJson.toJson(e.target.form);
        // console.log('Product - selectProduct: ', { productFormJsonValues });

        if (isAccessorySection) {
            let namedProductSection;
            if (selectedProducts['accessory1'] === null) {
                namedProductSection = 'accessory1';
            } else if (selectedProducts['accessory2'] === null) {
                namedProductSection = 'accessory2';
            } else if (selectedProducts['accessory3'] === null) {
                namedProductSection = 'accessory3';
            } else if (selectedProducts['accessory4'] === null) {
                namedProductSection = 'accessory4';
            } else {
                namedProductSection = 'accessory1';
            }

            onSelectNamedProduct(
                currentBuildIndex,
                product,
                '',
                '',
                product.variants && product.variants.nodes[0],
                namedProductSection,
                productFormJsonValues
            );

            // Brower.js:
            /*
            dispatch(
                selectNamedProduct(
                    product,
                    attributes,
                    addons,
                    product_attribute,
                    productSection,
                    productFormJsonValues
                )
            */
        } else {
            onSelect(product, '', '', product.variants && product.variants.nodes[0], productFormJsonValues);
        }
    };

    let button = (
        <button type="button" className="btn button span" onClick={(e) => selectProduct(e)}>
            <span>Add</span>
        </button>
    );

    if (isSelected) {
        button = (
            <button type="button" className="btn button span inverse" onClick={() => onRemove(section)}>
                <span>Remove</span>
            </button>
        );
    } else if (isCustomisable || product.variants?.nodes?.length > 1 || section === 'bodies') {
        button = (
            <button type="button" className="btn button span" onClick={() => onCustomise(product)}>
                <span>Customise</span>
            </button>
        );
    }

    if (isAccessorySection) {
        for (let i = 1; i <= 4; i += 1) {
            const section = `accessory${i}`;
            if (product.id === selectedProducts[section]?.product.id) {
                button = (
                    <button type="button" className="btn button span inverse" onClick={() => onRemove(section)}>
                        <span>Remove</span>
                    </button>
                );
            }
        }
    }

    const prodPrice = product?.priceRange?.minVariantPrice.amount;

    return (
        <li className={classes} key={product.id}>
            <button type="button" className="product-customise 1" onClick={() => onCustomise(product)}>
                <img src={imgSrc} width="480" height="480" alt="" loading="lazy" />
            </button>

            <ProductWarningText product={product} />

            <span className="product-title">
                <form
                    action="/cart/add"
                    method="post"
                    encType="multipart/form-data"
                    id={`AddToCartForm-${prodIdParsed}`}
                >
                    <input type="number" name="quantity" value="1" hidden readOnly />
                    <input
                        name="id"
                        value={product.variants?.nodes ? product.variants?.nodes[0]?.id?.split('/').pop() : ''}
                        hidden
                        readOnly
                    />
                    <input
                        type="text"
                        id={`projectTitle-${
                            product.variants?.nodes ? product.variants?.nodes[0]?.id?.split('/').pop() : ''
                        }`}
                        name="properties[projectTitle]"
                        value={projectTitle ? projectTitle : ''}
                        hidden
                        readOnly
                    />

                    {!product.availableForSale || !isInStock ? (
                        <p className="btn button span disabled">
                            <span>Sold out</span>
                        </p>
                    ) : (
                        button
                    )}
                </form>

                {product?.title?.split('-')[0]}
            </span>

            <span
                className="product-price"
                dangerouslySetInnerHTML={{
                    __html: `£${prodPrice}`,
                }}
            />
        </li>
    );
};

Product.propTypes = {
    product: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    onRemove: PropTypes.func,
    onCustomise: PropTypes.func,
};

Product.defaultProps = {
    isSelected: false,
    onSelect: () => {},
    onRemove: () => {},
    onCustomise: () => {},
};

export default Product;
